import React from 'react';
import { Rocket } from 'lucide-react';

export function PrelaunchBanner() {
  return (
    <div className="w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white">
      <div className="max-w-6xl mx-auto px-4 py-3 text-center">
        <div className="flex items-center justify-center gap-2">
          <Rocket className="h-5 w-5" />
          <span className="text-sm md:text-base font-medium">
            Beta is live! Running into issues?{' '}
            <a
              href="mailto:support@jdsimplified.com"
              className="underline hover:text-orange-100 transition-colors"
            >
              Email us
            </a>
            {' '}with your questions or concerns.
          </span>
        </div>
      </div>
    </div>
  );
}